<template>
  <div>
    <b-card class="mt-4">
      <div v-show="!isLoaded">
        <Loading ref="loadingSpinner"></Loading>
      </div>
      <div v-if="isLoaded">
        <b-overlay :show="busy" rounded="sm">
          <div class="row pb-3">
            <div class="col">
              <h3>Receptury dla kuwertur</h3>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary float-right" @click="OpenModal">
                <i class="fas fa-plus-circle fa-1x" /> Dodaj recepturę
              </button>
            </div>
          </div>

          <table class="table table-striped table-sm">
            <tr>
              <th>Nazwa</th>
              <th>Składniki</th>
              <th>Akcje</th>
            </tr>
            <tr v-for="item in items" :key="item.id">
              <td>
                <div class="raw-material-eco" v-if="item.recipeType == 0">
                  EKO - {{ item.name }}
                </div>
                <div class="raw-material-convention" v-else>
                  Konwencja - {{ item.name }}
                </div>
              </td>
              <td>
                <div class="container">
                  <div class="row">
                    <div class="col-8"><b>Nazwa</b></div>
                    <div class="col-4"><b>Waga (kg)</b></div>
                  </div>
                  <div class="row" v-for="ingredient in item.ingredients" :key="ingredient.id">
                    <div class="col-8 py-1 border-bottom">
                      <ecoConventionIcon :productType="ingredient.productType" />
                      {{ ingredient.name }}
                    </div>
                    <div class="col-4 py-1 border-bottom">{{ ingredient.weight }}</div>
                  </div>
                </div>
              </td>
              <td class="div-icons-area">
                <span @click="OpenModalInEdit(item)" v-b-tooltip.hover title="Edytuj recepturę">
                  <i class="fas fa-edit fa-lg" />
                </span>
                <span v-b-tooltip.hover title="Usuń recepturę" @click="RemoveItem(item)">
                  <i class="fas fa-trash fa-lg" />
                </span>
              </td>
            </tr>
          </table>

          <b-modal no-close-on-backdrop size="lg" v-model="modal.showModal" title="Edycja receptury" ok-title="Zapisz"
            cancel-title="Anuluj" @ok="SaveData()">
            <label>Nazwa receptury</label>
            <input type="text" class="form-control" placeholder="Nazwa receptury" v-model="modal.name" />
            <label>Rodzaj receptury</label>
            <v-select label="name" :options="recipeTypesSrc" v-model="modal.recipeType" :reduce="(x) => x.id"></v-select>
            <hr />
            <AdminitrationRecipesItem v-for="item in modal.recipe" :key="item.id" :selectedItem="item"
              :products="products" />

            <button type="button" class="btn btn-primary mt-2" @click="AddProduct">
              <i class="fas fa-plus-circle fa-1x" /> Dodaj składnik
            </button>
          </b-modal>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import Loading from "../../Common/Loading";
import AdminitrationRecipesItem from "./Adminitration_Recipes_Item";
import recipesMixin from "../../../mixins/recipes"
import deliveryMixin from "../../../mixins/delivery";
import ecoConventionIcon from '../../../common/ecoConventionIcon.vue'

export default {
  name: "RecipeAdministration",
  components: { Loading, AdminitrationRecipesItem, ecoConventionIcon },
  mixins: [urlConfig, toastr, recipesMixin, deliveryMixin],
  computed: {
    products() {
      return this.$store.state.deliveryFormData.rawMaterialTypes;
    },
    recipeTypesSrc() {
      return this.$store.state.coatingProductRecipe.recipesTypes;
    },
  },
  watch: {
    "modal.recipe": {
      handler(value) {
        if (value !== undefined && value.length > 0) {
          const isAnyKonwencja = value.filter(x => x?.productType == this.rawMaterialTypeKonwencja).length > 0
          this.modal.recipeType = isAnyKonwencja ? this.rawMaterialTypeKonwencja : this.rawMaterialTypeEko;
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$store.dispatch("getDeliveryFromData");
    this.Getitems();
  },
  data() {
    return {
      quesationText: "Czy napewno chcesz usunać recepturę: ",
      newItemSuccess: "Nowa receptura został dodana: ",
      editItemSuccess: "Receptura został zedytowana.",
      busy: false,
      items: [],
      isLoaded: false,
      modal: {
        name: "",
        recipe: [],
        showModal: false,
        isEdit: false,
        recipeType: 0,
      },
    };
  },
  methods: {
    AddProduct() {
      this.modal.recipe.push({});
    },
    OpenModal() {
      this.modal = {
        showModal: true,
        recipe: [],
        name: "",
        isEdit: false
      }
      this.modal.recipe.push({});
    },
    OpenModalInEdit(item) {
      var that = this;
      this.modal = {
        showModal: true,
        name: item.name,
        id: item.id,
        recipe: [],
        isEdit: true,
        recipeType: item.recipeType,
      }

      item.ingredients.forEach((x) => {
        var products = this.products.filter((p) => p.name == x.name);
        if (products.length > 0) {
          that.modal.recipe.push({
            rawMaterial: products[0],
            rawMaterialWeight: x.weight,
            productType: x.productType,
          });
        }
      });
    },
    Getitems() {
      var that = this;
      this.getRecipes()
        .then(function (response) {
          response.data.forEach(function (entry) {
            entry.isEdit = false;
          });
          that.items = response.data;
          that.isLoaded = true;
        })
        .catch(function (e) {
          console.log(e);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        });
    },
    AddItem() {
      this.items.push({ isEdit: true });
    },
    SaveData() {
      if (this.modal.isEdit) {
        this.UpdateItem();
      } else {
        this.SaveNewItem();
      }
    },

    SaveNewItem() {
      var that = this;
      this.busy = true;
      var ingredients = this.modal.recipe
        .filter((x) => x.rawMaterial != undefined)
        .map((x) => ({
          name: x.rawMaterial.name,
          weight: x.rawMaterialWeight,
          IngredientId: x.rawMaterial.id,
          productType: x.productType
        }));

      this.createNewRecipe({
        name: this.modal.name,
        ingredients: ingredients,
        recipeType: that.modal.recipeType
      })
        .then(function (response) {
          that.DisplaySuccess("Sukces!", that.newItemSuccess + that.modal.name);
          that.busy = false;
          that.items.push({
            id: response.data,
            name: that.modal.name,
            ingredients: ingredients,
            recipeType: that.modal.recipeType,
          });
        })
        .catch(function (e) {
          that.busy = false;
          console.log(e);
          that.DisplayError("Błąd!", "Dodanie nowej receptury nie powiodło się");
        });
    },

    UpdateItem() {
      var that = this;
      this.busy = true;
      var ingredients = this.modal.recipe
        .filter((x) => x.rawMaterial != undefined)
        .map((x) => ({
          name: x.rawMaterial.name,
          weight: x.rawMaterialWeight,
          ingredientId: x.rawMaterial.id,
          productType: x.productType,
        }));
      this.editRecipe({
        id: this.modal.id,
        name: this.modal.name,
        ingredients: ingredients,
        recipeType: this.modal.recipeType,
      })
        .then(function () {
          that.DisplaySuccess("Sukces!", that.editItemSuccess);
          that.busy = false;
          that.Getitems();
        })
        .catch(function (e) {
          that.busy = false;
          console.log(e);
          that.DisplayError("Błąd!", "Aktualizacja receptury nie powiodła się");
        });
    },
    RemoveItem(item) {
      if (confirm(this.quesationText + item.name)) {
        var that = this;
        this.busy = true;
        this.removeRecipe({ id: item.id })
          .then(function () {
            that.items = that.items.filter((x) => x.id != item.id);
            that.busy = false;
          })
          .catch(function (e) {
            console.log(e);
            that.busy = false;
            that.DisplayError("Błąd!", "Usunięcie receptury nie powiodło się");
          });
      }
    },
  },
};
</script>